/** PA Working Hours API (BOXY-523). Times are ISO UTC; format them with formatTimeBaghdad. */
import api from './api';

export interface ScanMark { kind: 'L' | 'D'; from: string; to: string; orders: number }
export interface StopMark { kind: 'P' | 'R'; at: string; tasks: number }
export interface PaShift {
  driverId: number; driverUid: string; name: string | null; day: string;
  start: string | null; startFrom: 'load scan' | 'pickup' | 'RTO drop' | null; end: string | null;
  shiftH: number | null; breakH: number | null; workingH: number | null; idleMin: number | null;
  scheduled: { start: string; end: string } | null; lateStartMin: number | null; earlyFinishMin: number | null;
  pickups: number; rtoDrops: number; stops: number; stopsPerH: number | null; visits: number;
  dropAfterCutoff: string | null; status: 'on shift' | 'finished' | null; notes: string[];
  marks?: { scans: ScanMark[]; stops: StopMark[]; idle: { from: string; to: string }[] };
}

export const workingHoursApi = {
  getDay: async (date?: string) =>
    (await api.get<{ success: boolean; data: { date: string; rows: PaShift[] } }>('/working-hours/day', { params: { date } })).data.data,
  getDriverWeek: async (driverId: number, to?: string) =>
    (await api.get<{ success: boolean; data: { to: string; days: PaShift[] } }>(`/working-hours/driver/${driverId}`, { params: { to } })).data.data,
};
